module.exports = __webpack_public_path__ + "static/media/sitekick-logo-text.5e433b17.svg";